module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.parsedData.email))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [(this.$route.params.id) ? _c('submenu') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form js-form view__split"
  }, [_c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Label_MemberData")))]), _vm._v(" "), _c('fieldset', {
    staticClass: "form__field"
  }, [_c('div', {
    staticClass: "tags"
  }, [(_vm.member.isActive) ? _c('span', {
    staticClass: "tags__item tags__item--active"
  }, [_vm._v(_vm._s(_vm.L.localize("MemberData_IsActive")))]) : _c('span', {
    staticClass: "tags__item tags__item--inactive"
  }, [_vm._v(_vm._s(_vm.L.localize("MemberData_IsNotActive")))])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form__field"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("\n              " + _vm._s(_vm.L.localize("Members_Groups")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.member.groups), function(group) {
    return _c('span', {
      staticClass: "tags__item"
    }, [_vm._v(_vm._s(group.name))])
  }), 0)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form__field"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("\n              " + _vm._s(_vm.L.localize("Members_Subscription")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [(!_vm.member.unsubscribed) ? _c('span', {
    staticClass: "tags__item tags__item--active"
  }, [_vm._v(_vm._s(_vm.L.localize("Label_Subscribed")))]) : _c('span', {
    staticClass: "tags__item tags__item--inactive"
  }, [_vm._v(_vm._s(_vm.L.localize("Label_Unsubscribed")))])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form__field"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("\n              " + _vm._s(_vm.L.localize("MemberData_CreationTime")) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.Format.date(_vm.member.creationTime)))])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form__field"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("\n              " + _vm._s(_vm.L.localize("MemberData_LastModificationDate")) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.Format.date(_vm.member.lastModificationTime)))])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form js-form view__split"
  }, [_c('div', {
    staticClass: "jquery-alpaca"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c4756a4!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/members/MemberDetail.vue
// module id = 702
// module chunks = 1